import React from "react";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { validarCedulaUruguaya } from "../helpers/ciUtils";
import { pushDataLayer } from "../gtm";

const departamentos = [
  "Artigas", "Canelones", "Cerro Largo", "Colonia", "Durazno",
  "Flores", "Florida", "Lavalleja", "Maldonado", "Montevideo",
  "Paysandú", "Río Negro", "Rivera", "Rocha", "Salto",
  "San José", "Soriano", "Tacuarembó", "Treinta y Tres"
];

export default function Step4({ formData, setFormData, next, prev }) {
  const handleAceptar = (e) => {
    e.preventDefault();

    const errores = [];

    // 1) Verificar que se haya ingresado algo en cédula
    const cedulaIngresada = (formData.cedula || "").trim();
    if (!cedulaIngresada) {
      errores.push("La cédula no puede estar vacía.");
    } else if (!validarCedulaUruguaya(cedulaIngresada)) {
      // 2) Validar la cédula
      errores.push("La cédula ingresada no es válida.");
    }

    // 3) Verificar que se haya seleccionado un departamento
    if (!formData.departamento) {
      errores.push("Por favor, seleccioná tu departamento.");
    }

    if (errores.length > 0) {
      // Mostrar SweetAlert con todos los errores
      Swal.fire({
        icon: "error",
        title: "Errores en el formulario",
        html: errores.join("<br/>"),
        confirmButtonText: "Entendido",
        confirmButtonColor: "#d33",
        customClass: {
          popup: "swal2-no-radius"
        },
        backdrop: "rgba(0, 0, 0, 0.8)"
      });
      return;
    }

    // Si no hay errores, dispara evento y avanza
    pushDataLayer('paso5_fecha_nacimiento');
    next();
  };

  return (
    <div className="form-container">
      <Form onSubmit={handleAceptar}>
        <Form.Group className="mb-4">
          <h2 className="form-title">¿Cuál es tu número de cédula?</h2>
          <Form.Label>Cédula</Form.Label>
          <Form.Control
            type="text"
            placeholder="Sin puntos ni guiones"
            value={formData.cedula}
            maxLength={8}
            onChange={(e) => {
              // Aceptar solo dígitos
              const valorSinCaracteres = e.target.value.replace(/\D/g, "");
              setFormData({ ...formData, cedula: valorSinCaracteres });
            }}
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <h2 className="form-title">¿En qué departamento vivís?</h2>
          <Form.Label>Departamento</Form.Label>
          <Form.Select
            value={formData.departamento}
            onChange={(e) => {
              const departamento = e.target.value;
              const mantieneBarrio = formData.modalidad === 'Presencial' &&
                ['Montevideo', 'Canelones'].includes(departamento);

              setFormData({
                ...formData,
                departamento,
                barrio: mantieneBarrio ? formData.barrio : ''
              });
            }}
          >
            <option value="">Seleccioná tu departamento</option>
            {departamentos.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <div className="d-flex justify-content-between">
          <Button variant="secondary" onClick={prev}>
            Atrás
          </Button>
          <Button variant="primary" type="submit">
            Aceptar
          </Button>
        </div>
      </Form>
    </div>
  );
}
